module.exports = __webpack_public_path__ + "img/speckle.41f5904e.png";